import {MAXIMUM_TRANSCRIPT_AUDIO_FILE_SIZE, SNACKBAR_ACTIONS} from '../const';

const {
  ADD_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  TECHNICAL_ERROR,
  SEND_CONTACT_MESSAGE_SUCCESS,
  IMPORT_PROJECT_FILES_SUCCESS,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_SUCCESS_WITH_NAME,
  UPDATE_PROJECT_SUCCESS,
  REFRESH_PROJECT_LOADING,
  REFRESH_PROJECT_SUCCESS,
  PROMOTE_USER_SUCCESS,
  DEMOTE_USER_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_PARTIAL,
  UPDATE_PROFILE_ERROR,
  SUBSCRIBE_LOADING,
  UPLOAD_ERROR_DOCUMENT_TYPE,
  CREATE_CONNECTION_DATA_INTEGRATION_IN_PROGRESS,
  PENNYLANE_DATA_INTEGRATION_COMPLETED,
  CREATE_CONNECTION_DATA_INTEGRATION_ERROR,
  CREATE_WORKSPACE_SUCCESS,
  CREATE_REPORT_SUCCESS,
  DELETE_WORKSPACE_SUCCESS,
  REPORT_SUCCESSFULLY_SAVED,
  SEND_CHATBOT_MESSAGE_ERROR,
  SUBSCRIBE_ERROR_EMAIL_ALREADY_TAKEN,
  DELETE_BUDGET_IN_PROGRESS,
  DELETE_BUDGET_SUCCESS,
  UPDATE_SPREADSHEET_DATA_IN_PROGRESS,
  UPDATE_SPREADSHEET_DATA_SUCCESS,
  UPDATE_SPREADSHEET_DATA_ERROR,
  UPLOAD_ERROR_TOO_MANY_FILES,
  IMPORT_REPORT_SUCCESS,
  EXPORT_REPORT_IN_PROGRESS,
  EXPORT_REPORT_SUCCESS,
  UPDATE_REPORT_SUMMARY,
  UPDATE_REPORT_SUMMARY_SUCCESS,
  SEND_DOCUMENT_REQUEST_SUCCESS,
  USER_HAS_DECLINED_MICROPHONE_PERMISSION,
  TRANSCRIPTION_AUDIO_FILE_EXCEEDS_MAXIMUM_SIZE,
  TRANSCRIPTION_AUDIO_FILE_WILL_SOON_EXCEED_MAXIMUM_SIZE_WARNING,
  INVALID_TRANSCRIPTION,
  CREATE_PROMPT_MODEL_SUCCESS,
  DELETE_PROMPT_MODEL_SUCCESS,
  UPDATE_REPORT_SUMMARY_WITH_AUDIO,
  RESET_CUSTOM_MAPPING_IN_PROGRESS,
  RESET_CUSTOM_MAPPING_SUCCESS,
  UPDATE_CUSTOM_MAPPING_IN_PROGRESS,
  UPDATE_CUSTOM_MAPPING_SUCCESS,
  UPDATE_PROJECT_IN_PROGRESS,
  IMPORT_REPORT_IN_PROGRESS,
  DELETE_REPORT_IN_PROGRESS,
  DELETE_WORKSPACE_IN_PROGRESS,
  CREATE_WORKSPACE_IN_PROGRESS,
  CREATE_PROJECT_IN_PROGRESS,
  DELETE_PROJECT_IN_PROGRESS,
  DELETE_PROJECT_SUCCESS,
  IMPORT_PROJECT_FILES_IN_PROGRESS,
  IMPORT_PROJECT_FILES_ERROR,
  DELETE_THREAD_IN_PROGRESS,
  DELETE_THREAD_SUCCESS,
  DELETE_PROMPT_MODEL_IN_PROGRESS,
  GENERATE_ANALYSIS_IN_PROGRESS,
  DELETE_EDITOR_CONNECTION,
  DELETE_EDITOR_CONNECTION_SUCCESS,
  SAVE_REPORT_VIEW_IN_PROGRESS,
  SAVE_REPORT_VIEW_SUCCESS,
  APPLY_VIEW_SUCCESS,
  DELETE_REPORT_VIEW_IN_PROGRESS,
  DELETE_REPORT_VIEW_SUCCESS,
  RESET_REPORT_VIEW_SUCCESS,
  CREATE_REPORT_IN_PROGRESS,
  EXPORT_BUDGET_FILE_IN_PROGRESS,
  EXPORT_BUDGET_FILE_SUCCESS,
  IMPORT_BUDGET_FILE_SUCCESS,
  IMPORT_BUDGET_FILE_IN_PROGRESS,
  EXPORT_PLATFORM_USAGE_DATA_IN_PROGRESS,
  EXPORT_PLATFORM_USAGE_DATA_SUCCESS,
  TOGGLE_ADMIN_MODE_IN_PROGRESS,
  TOGGLE_ADMIN_MODE_SUCCESS,
  CREATE_BUDGET_IN_PROGRESS,
  CREATE_BUDGET_SUCCESS,
  ADD_FISCAL_YEAR_TO_BUDGET_SUCCESS,
  ADD_FISCAL_YEAR_TO_BUDGET,
  CREATE_PRACTITIONER,
  CREATE_PRACTITIONER_SUCCESS,
  UPDATE_PRACTITIONER,
  UPDATE_PRACTITIONER_SUCCESS,
  ADD_PRACTITIONER_ACTIVITIES,
  ADD_PRACTITIONER_ACTIVITIES_SUCCESS,
  DELETE_PRACTITIONER,
  DELETE_PRACTITIONER_SUCCESS,
  UPDATE_USER_SECRET,
  UPDATE_USER_SECRET_SUCCESS,
  CREATE_CONNECTION_DATA_INTEGRATION_SUCCESS,
  UPDATE_REPORT_IN_PROGRESS,
  UPDATE_REPORT_SUCCESS,
  UPDATE_SOURCE_IN_PROGRESS,
  UPDATE_PARAMETERS_IN_PROGRESS,
  UPDATE_PARAMETERS_SUCCESS,
  SCHEDULE_REPORT_UPDATE_IN_PROGRESS,
  SCHEDULE_REPORT_UPDATE_SUCCESS,
  ACTUALIZE_DATASOURCES,
  ACTUALIZE_DATASOURCES_SUCCESS
} = SNACKBAR_ACTIONS;

// eslint-disable-next-line complexity
export const getSnackbarMessage = (actionOrMessage, data) => {
  const {
    createdProjectName,
    firstFiscalMonthHasChanged,
    projectRefreshing,
    promotedUserEmail,
    demotedUserEmail,
    newUserUsername,
    workspaceName,
    reportName,
    acceptedExtensions,
    exportedReportName,
    currentFileSize,
    exportedBudgetName,
    isDisablingAdminMode,
    budgetYear,
    budgetName,
    numberOfIntegratedFolders,
    totalNumbersOfFoldersToIntegrate,
    deletedConnectionName,
    integratedFoldersNames,
    updatedReportName
  } = data;

  switch (actionOrMessage) {
    case CREATE_CONNECTION_DATA_INTEGRATION_SUCCESS:
      return `Données intégrées avec succès : ${integratedFoldersNames.join(', ')}`;
    case UPDATE_USER_SECRET:
      return 'Mise à jour du secret en cours';
    case ACTUALIZE_DATASOURCES:
      return "Sources en cours d'actualisation";
    case ACTUALIZE_DATASOURCES_SUCCESS:
      return 'Sources actualisées avec succès';
    case UPDATE_SOURCE_IN_PROGRESS:
      return 'Mise à jour de la source en cours';
    case SCHEDULE_REPORT_UPDATE_IN_PROGRESS:
      return 'Enregistrement de la planification en cours';
    case SCHEDULE_REPORT_UPDATE_SUCCESS:
      return 'Actualisation planifiée avec succès';
    case UPDATE_PARAMETERS_IN_PROGRESS:
      return 'Mise à jour des paramètres du rapport en cours';
    case UPDATE_PARAMETERS_SUCCESS:
      return 'Les paramètres du rapport ont été mis à jour avec succès';
    case UPDATE_REPORT_IN_PROGRESS:
      // return `Actualisation du rapport "${updatedReportName}" en cours`;
      return `Actualisation du rapport en cours`;
    case UPDATE_REPORT_SUCCESS:
      return `Actualisation du rapport terminée`;
    case UPDATE_USER_SECRET_SUCCESS:
      return 'Secret mis à jour avec succès';
    case DELETE_PRACTITIONER:
      return 'Suppression du praticien en cours';
    case DELETE_PRACTITIONER_SUCCESS:
      return 'Praticien supprimé avec succès';
    case ADD_PRACTITIONER_ACTIVITIES:
      return 'Mise à jour des informations en cours';
    case ADD_PRACTITIONER_ACTIVITIES_SUCCESS:
      return 'Informations mises à jour avec succès';
    case UPDATE_PRACTITIONER:
      return 'Mise à jour du praticien en cours';
    case UPDATE_PRACTITIONER_SUCCESS:
      return 'Praticien mis à jour avec succès';
    case CREATE_PRACTITIONER:
      return 'Ajout du praticien en cours';
    case CREATE_PRACTITIONER_SUCCESS:
      return 'Praticien ajouté avec succès';
    case TOGGLE_ADMIN_MODE_IN_PROGRESS:
      return `${isDisablingAdminMode ? 'Désactivation' : 'Activation'} du mode admin`;
    case TOGGLE_ADMIN_MODE_SUCCESS:
      return `Mode admin ${isDisablingAdminMode ? 'désactivé' : 'activé'} avec succès`;
    case EXPORT_PLATFORM_USAGE_DATA_IN_PROGRESS:
      return 'Export en cours';
    case CREATE_BUDGET_IN_PROGRESS:
      return 'Création du budget en cours';
    case CREATE_BUDGET_SUCCESS:
      return 'Budget créé avec succès !';
    case ADD_FISCAL_YEAR_TO_BUDGET:
      return "Ajout de l'année au budget en cours";
    case ADD_FISCAL_YEAR_TO_BUDGET_SUCCESS:
      return 'Année ajoutée au budget avec succès';
    case EXPORT_PLATFORM_USAGE_DATA_SUCCESS:
      return 'Export terminé';
    case DELETE_EDITOR_CONNECTION:
      return 'Suppression de la connexion en cours';
    case EXPORT_BUDGET_FILE_IN_PROGRESS:
      return `Export de ${exportedBudgetName} en cours`;
    case EXPORT_BUDGET_FILE_SUCCESS:
      return `${exportedBudgetName} exporté avec succès`;
    case IMPORT_BUDGET_FILE_IN_PROGRESS:
      return 'Import du budget en cours';
    case IMPORT_BUDGET_FILE_SUCCESS:
      return 'Budget importé avec succès';
    case DELETE_EDITOR_CONNECTION_SUCCESS:
      return 'La connexion a été supprimée avec succès !';
    case DELETE_PROMPT_MODEL_IN_PROGRESS:
      return `Le modèle est en cours de suppression`;
    case GENERATE_ANALYSIS_IN_PROGRESS:
      return `Génération de l'analyse en cours`;
    case CREATE_CONNECTION_DATA_INTEGRATION_IN_PROGRESS:
      return `Vos données sont en cours d'intégration (${numberOfIntegratedFolders} / ${totalNumbersOfFoldersToIntegrate})`;
    case DELETE_THREAD_IN_PROGRESS:
      return `Suppression de la conversation en cours`;
    case DELETE_THREAD_SUCCESS:
      return `La conversation a supprimée avec succès !`;
    case PENNYLANE_DATA_INTEGRATION_COMPLETED:
      return `L'intégration de vos données est terminée !`;
    case CREATE_CONNECTION_DATA_INTEGRATION_ERROR:
      return `Une erreur est survenue au cours de l'intégration des données.`;
    case ADD_USER_SUCCESS:
      return `Dossier partagé avec ${newUserUsername} !`;
    case DELETE_USER_SUCCESS:
      return 'Utilisateur supprimé avec succès !';
    case TECHNICAL_ERROR:
      return 'Une erreur est survenue. Nos équipes sont prévenues et le problème est en cours de résolution.';
    case SEND_CONTACT_MESSAGE_SUCCESS:
      return 'Votre message a bien été envoyé !';
    case DELETE_BUDGET_IN_PROGRESS:
      return budgetYear ? `Année ${budgetYear} de ${budgetName} en cours de suppression.` : `${budgetName} en cours de suppression.`;
    case DELETE_BUDGET_SUCCESS:
      return 'Budget supprimé avec succès !';
    case DELETE_REPORT_IN_PROGRESS:
      return 'Suppression du rapport en cours';
    case IMPORT_PROJECT_FILES_SUCCESS:
      return 'Nous avons bien reçu vos fichiers. Vous pouvez maintenant consulter votre tableau de bord.';
    case IMPORT_PROJECT_FILES_IN_PROGRESS:
      return 'Import de vos données en cours';
    case IMPORT_PROJECT_FILES_ERROR:
      return `Une erreur est survenue lors de l'import de vos données.`;
    case CREATE_PROJECT_SUCCESS:
      return 'Dossier créé avec succès !';
    case CREATE_PROJECT_IN_PROGRESS:
      return 'Création du dossier en cours';
    case CREATE_PROJECT_SUCCESS_WITH_NAME:
      return `Dossier ${createdProjectName} créé avec succès`;
    case UPDATE_PROJECT_IN_PROGRESS:
      return `Sauvegarde du dossier en cours`;
    case UPDATE_PROJECT_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const fiscalMonthHasChangedText = firstFiscalMonthHasChanged ? `La modification sera effective dans votre rapport d'ici quelques minutes` : '';
      return `Les paramètres de la connexion ont été mis à jour ! ${fiscalMonthHasChangedText}`;
    case REFRESH_PROJECT_LOADING:
      return `${projectRefreshing} en cours d'actualisation.`;
    case REFRESH_PROJECT_SUCCESS:
      return `Actualisation terminée.`;
    case PROMOTE_USER_SUCCESS:
      return `${promotedUserEmail} est désormais propriétaire !`;
    case DEMOTE_USER_SUCCESS:
      return `${demotedUserEmail} est désormais invité !`;
    case UPDATE_PROFILE_SUCCESS:
      return 'Votre profil a bien été mis à jour !';
    case UPDATE_PROFILE_PARTIAL:
      return "Votre profil a été partiellement mis à jour. Le numéro de téléphone n'a pas pu être modifié...";
    case UPDATE_PROFILE_ERROR:
      return "Votre profil n'a pas pu être mis à jour. Veuillez réessayer plus tard...";
    case UPLOAD_ERROR_DOCUMENT_TYPE:
      return `Les fichiers doivent être au format ${acceptedExtensions}`;
    case UPLOAD_ERROR_TOO_MANY_FILES:
      return 'Vous avez sélectionné trop de fichiers.';
    case SUBSCRIBE_LOADING:
      return `Veuillez patienter pendant que nous vous donnons accès à l'application.`;
    case CREATE_WORKSPACE_SUCCESS:
      return `L'espace de travail " ${workspaceName} " a été créé avec succès !`;
    case CREATE_WORKSPACE_IN_PROGRESS:
      return `Création de l'espace de travail en cours`;
    case DELETE_WORKSPACE_IN_PROGRESS:
      return `Suppression de l''espace de travail en cours`;
    case DELETE_WORKSPACE_SUCCESS:
      return `L'espace de travail " ${workspaceName} " a été supprimé !`;
    case CREATE_REPORT_SUCCESS:
      return `Le rapport " ${reportName} " a été créé avec succès !`;
    case CREATE_REPORT_IN_PROGRESS:
      return `Rapport en cours de création`;
    case REPORT_SUCCESSFULLY_SAVED:
      return 'Votre rapport a bien été sauvegardé !';
    case SEND_CHATBOT_MESSAGE_ERROR:
      return "Une erreur est survenue lors de l'envoi de votre message";
    case SUBSCRIBE_ERROR_EMAIL_ALREADY_TAKEN:
      return 'Cette adresse mail est déjà utilisée. Si vous avez oublié votre mot de passe, réinitialisez-le';
    case UPDATE_SPREADSHEET_DATA_IN_PROGRESS:
      return 'Mise à jour en cours';
    case UPDATE_SPREADSHEET_DATA_SUCCESS:
      return 'Rapport actualisé';
    case IMPORT_REPORT_SUCCESS:
      return 'Le rapport a été importé avec succès';
    case IMPORT_REPORT_IN_PROGRESS:
      return 'Import du rapport en cours';
    case UPDATE_SPREADSHEET_DATA_ERROR:
      return 'Erreur lors de la mise à jour des données';
    case EXPORT_REPORT_IN_PROGRESS:
      return `Téléchargement du rapport '${exportedReportName}' en cours`;
    case EXPORT_REPORT_SUCCESS:
      return `Rapport '${exportedReportName}' téléchargé avec succès`;
    case UPDATE_REPORT_SUMMARY:
      return 'Veuillez patienter pendant la mise à jour du résumé';
    case UPDATE_REPORT_SUMMARY_WITH_AUDIO:
      return "Veuillez patienter pendant la mise à jour du résumé et la génération de l'audio";
    case UPDATE_REPORT_SUMMARY_SUCCESS:
      return 'Résumé mis à jour avec succès';
    case SEND_DOCUMENT_REQUEST_SUCCESS:
      return 'Votre demande a été envoyée';
    case TRANSCRIPTION_AUDIO_FILE_EXCEEDS_MAXIMUM_SIZE:
      return `Le fichier audio généré dépasse la taille maximale autorisé (${MAXIMUM_TRANSCRIPT_AUDIO_FILE_SIZE} Mo).`;
    case TRANSCRIPTION_AUDIO_FILE_WILL_SOON_EXCEED_MAXIMUM_SIZE_WARNING:
      return `Taille maximale de l'audio bientôt atteinte ( ${currentFileSize} / ${MAXIMUM_TRANSCRIPT_AUDIO_FILE_SIZE} Mo). Veuillez terminer votre enregistrement.`;
    case USER_HAS_DECLINED_MICROPHONE_PERMISSION:
      return "Vous devez autoriser l'accès au microphone pour pouvoir enregistrer";
    case INVALID_TRANSCRIPTION:
      return 'Erreur lors de l’envoi de vos données, veuillez réessayer';
    case CREATE_PROMPT_MODEL_SUCCESS:
      return 'Le modèle a été créé avec succès';
    case DELETE_PROJECT_IN_PROGRESS:
      return `Suppression de la connexion "${deletedConnectionName}" en cours`;
    case DELETE_PROJECT_SUCCESS:
      return `Connexion "${deletedConnectionName}" supprimée avec succès`;
    case DELETE_PROMPT_MODEL_SUCCESS:
      return 'Le modèle a été supprimé avec succès';
    case RESET_CUSTOM_MAPPING_IN_PROGRESS:
      return "Réinitialisation de l'affectation en cours";
    case RESET_CUSTOM_MAPPING_SUCCESS:
      return "Réinitialisation de l'affectation effectuée avec succès";
    case UPDATE_CUSTOM_MAPPING_IN_PROGRESS:
      return 'Mise à jour du plan des comptes en cours';
    case UPDATE_CUSTOM_MAPPING_SUCCESS:
      return 'Mise à jour du plan des comptes effectuée avec succès';
    case SAVE_REPORT_VIEW_IN_PROGRESS:
      return 'Sauvegarde de la vue en cours';
    case SAVE_REPORT_VIEW_SUCCESS:
      return 'La vue a été sauvegardée avec succès';
    case APPLY_VIEW_SUCCESS:
      return 'La vue a été appliquée';
    case DELETE_REPORT_VIEW_IN_PROGRESS:
      return 'Suppression de la vue en cours';
    case DELETE_REPORT_VIEW_SUCCESS:
      return 'La vue a été supprimée avec succès';
    case RESET_REPORT_VIEW_SUCCESS:
      return 'La vue a été réinitialisée avec succès';
    // Sometimes, we'll want to display a message from the API in the snackbar.
    // As we cannot hardcode the message here, we will directly pass it to getSnackbarMessage instead of passing an existing SNACKBAR_ACTION
    default:
      return actionOrMessage;
  }
};
